import React from 'react'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import facebookLogo from '../../assets/facebook.svg'

export const FacebookButton = ({ text = 'Continuar con facebook', onSuccess }) => {

  return (
    <FacebookLogin
      appId="224523496526013"
      autoLoad={false}
      fields="name,email,picture"
      callback={onSuccess}
      render={renderProps => (
        <button
          className='GoogleButton'
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
          type='button'
        >
          <img src={facebookLogo} alt="facebook logo" />
          {text}
        </button>
      )}
    />
  )
}